// extracted by mini-css-extract-plugin
export default {"overflowWrapper":"ajN6b","set":"mUMCm","catalog":"IXEf6"};